// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2P-6T","title":"card_title__3ABy3","inActive":"card_inActive__C7Wu8"};